import { defineComponent as _defineComponent } from 'vue'
import Icon from './Icon.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStarsNew',
  props: {
	blainNumber: String,
	color: {
		type: String,
		default: 'yellows',
	},
	shortReviews: Boolean,
	starSize: {
		type: String,
		default: '16px'
	},
	totalReviews: {
		type: Number,
		default: 0
	},
	rating: {
		type: Number,
		default: 0
	},
},
  setup(__props) {

const props = __props



const reviewsText = computed(() => {
	return props.shortReviews
		? `(${props.totalReviews})`
		: props.totalReviews > 1
			? `${props.totalReviews.toLocaleString()} Reviews`
			: `${props.totalReviews} Review`;
});

const width = computed(() => {
	const roundedRating = Math.floor(props.rating * 2) / 2; //round down to nearest .5 
	const widthPct = (roundedRating / 5) * 100;
	return `${widthPct}%`;
});

const starLabel = computed(() => {
	const ratingLabel = (props.totalReviews > 0 ? `Rated ${props.rating} stars` : 'No rating yet');
	return ratingLabel;
});

return { __sfc: true,props, reviewsText, width, starLabel, Icon }
}

})